export default __webpack_public_path__ + "static/media/login_icon.6b3b2124.svg";